module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hbox h-100"
  }, [_c('v-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "vbox",
    attrs: {
      "id": "contain"
    }
  }, [_c('v-head'), _vm._v(" "), _c('section', {
    staticClass: "contain p-3"
  }, [_c('transition', {
    attrs: {
      "name": "move",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a214049"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Home.vue
// module id = 595
// module chunks = 2